import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SqlService } from "../../Database/sql.service";

import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-select-superviser',
  templateUrl: './select-superviser.component.html',
  styleUrls: ['./select-superviser.component.css']
})
export class SelectSuperviserComponent implements OnInit {


  ProvidersData = [
    {
      ID: "",
      BoxSize: "",
      BatchSize: ""
    }];
  Provider = 0;


  BoxNumber = "";

  date = "";
  CurrentDate = "";

  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";

  firstscreen = true;
  Secondscreen = false;

  AllSerialBatchnumbers = [{}];
  AllSerialnumbers = [""];
  NewSerialnumbers = [""];
  AllocatedSerialnumbers = [""];


  InputSerialNumber = [""];

  ConfirmReset = "";
  SelectedBoxNumbers = [""];
  PossibleBoxNumbers = [""];
  PossibleBox = "";

  forceClose = false;

  constructor(private dbService: SqlService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal) { }

  ngOnInit(): void {
    let tempDate = new Date();
    this.CurrentDate = tempDate.getFullYear() + "-";
    let monthTemp = Number.parseInt(tempDate.getMonth().toString());
    monthTemp++;
    if (tempDate.getMonth().toString().length == 1) {
      this.CurrentDate += "0" + monthTemp + "-";
    } else {
      this.CurrentDate += monthTemp + "-";
    }

    if (tempDate.getDate().toString().length == 1) {
      this.CurrentDate += "0" + tempDate.getDate();
    } else {
      this.CurrentDate += tempDate.getDate();
    }


    this.SelectedBoxNumbers.pop();
    this.GetAllBoxNames(" Status = 'Recieved'");
    this.getAllData();
  }

  Province = "";
  Provinces = [""];
  Distributor = "";
  Distributors = [""];




  data = [
    {
      ID: "",
      Province: "",
      Active: ""

    }];
  async getAllData() {
    await (this.dbService.getAllDistrubutor().subscribe((ret: any) => {
      if (ret != "false") {
        this.Distributors.splice(0);
        this.Provinces.splice(0);
        this.data.splice(0);

        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          let elementtemp = element.split(",")

          if (elementtemp[2] == "Yes") {
            let temp = {
              ID: elementtemp[0],
              Province: elementtemp[1],
              Active: elementtemp[2]
            }

            this.data.push(temp);
            if (!(this.Provinces.includes(elementtemp[1]))) {
              this.Provinces.push(elementtemp[1]);
            }

          }



        });
      } else {

        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
      }
    }));

    await (this.dbService.getAllProviders().subscribe((ret: any) => {
      if (ret != "false") {
        this.ProvidersData.splice(0);
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          let elementtemp = element.split(",")
          let temp = {
            ID: elementtemp[0],
            BoxSize: elementtemp[1],//-> BoxSizeDirect
            BatchSize: elementtemp[2]// -> BatchSizeDirect
            //3 -> BoxSizeInDirect
            //4 ->BatchSizeInDirect
          }

          this.ProvidersData.push(temp);
        });

      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
      }
    }));
  }

  ProvinceChanged() {
    this.Distributors.splice(0);
    this.data.forEach(element => {
      if (element.Province == this.Province) {
        this.Distributors.push(element.ID);
      }
    });
  }


  PossibleBoxChanged() {
    this.BoxNumber = this.PossibleBox[0];
  }

  Back() {
    this.firstscreen = true;
    this.Secondscreen = false;
  }

  TimeOutForInputBoxNumber: any = null;
  BoxNameChanged(event: any) {
    clearTimeout(this.TimeOutForInputBoxNumber);
    var $this = this;
    this.TimeOutForInputBoxNumber = setTimeout(function () {
      $this.executeSearchForPossibleBoxNumbers(event.target.value);
    }, 500);
  }

  executeSearchForPossibleBoxNumbers(value: string) {
    this.GetAllBoxNames(" ( Status = 'Recieved') AND ([Pactel].[dbo].[Boxes].Boxno like '" + value + "%') ");
  }


  async GetAllBoxNames(condition: string) {
    Swal.fire({
      title: 'Loading Boxes',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });


    this.PossibleBoxNumbers.splice(0);

    var formData = new FormData(); // Currently empty
    formData.set("Where", condition);


    await (this.dbService.getTopBoxesNames(formData).subscribe((ret: any) => {
      if (ret != "false") {

        let a = (ret as string).split(';');
        a.forEach(element => {
          this.PossibleBoxNumbers.push(element);
        });

        Swal.close();
      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    }));
  }


  AddBox() {

    if (this.PossibleBoxNumbers.indexOf(this.BoxNumber) != -1) {
      if (this.SelectedBoxNumbers.indexOf(this.BoxNumber) == -1) {
        this.SelectedBoxNumbers.push(this.BoxNumber);
      }
    }
  }
  RemoveBox() {
    if (this.SelectedBoxNumbers.indexOf(this.BoxNumber) != -1) {
      this.SelectedBoxNumbers = this.SelectedBoxNumbers.filter(x => x !== this.BoxNumber);
    }
  }


  Reset() {
    this.Province = "";
    this.Distributor = "";
    this.Distributors.splice(0);
    this.BoxNumber = "";
    this.Provider = 0;
    this.SelectedBoxNumbers = [];

    this.InputSerialNumber.splice(0);
    this.NewSerialnumbers.splice(0);
    this.AllSerialBatchnumbers.splice(0);
    this.AllSerialnumbers.splice(0);
    this.AllocatedSerialnumbers.splice(0);

    this.firstscreen = true;
    this.Secondscreen = false;
  }


  async Next() {
    var formData = new FormData();

    var sqlWhereStatement = "('";
    this.SelectedBoxNumbers.forEach(element => {
      sqlWhereStatement += element + "','";
    });
    sqlWhereStatement = sqlWhereStatement.substring(0, sqlWhereStatement.length - 2) + ")";


    formData.set("WhereIn", sqlWhereStatement);
    formData.set("Distributor", this.Distributor);
    formData.set("Provider", this.ProvidersData[this.Provider].ID);
    formData.set("selectedDate", this.date);


    await (this.dbService.SelectSuperviser(formData).subscribe((ret: any) => {
      if (!(String(ret).includes("Error"))) {

        this.PopupTitle = "Success"
        this.DisplayErrormessage = "The Supervisor has been selected";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        this.Reset();
        this.GetAllBoxNames(" Status = 'Recieved'");
      } else {
        //"Error.Duplicate entry 'Box1-1' for key 'PRIMARY'"
        console.log(ret);
        if ((String(ret).includes("Duplicate entry")) || (String(ret).includes("duplicate key"))) {
          let tepError = String(ret).replace("Error.", "");
          tepError = tepError.replace(" for key 'PRIMARY'", "") + "(Serial Number)";

          this.PopupTitle = "Invalid Details"
          this.DisplayErrormessage = tepError;
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        } else {

          this.PopupTitle = "Error"
          this.DisplayErrormessage = "Please check your internet connection and try again";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        }
      }
    }));
  }





  ForceClose() {

    this.ConfirmReset = "";
    this.PopupTitle = "Warning!"
    this.DisplayErrormessage = "Please type in 'DONE' below to FORCE close the box.";
    let element: HTMLButtonElement = document.getElementById('btnConfirmClose') as HTMLButtonElement;
    element.click();
  }


  open(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = 'Closed with: ${result}';
      }, (reason) => {
        this.closeResult =
          'Dismissed ${this.getDismissReason(reason)}';
        //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        //element.click();
      });
  }

  open2(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = 'Closed with: ${result}';
      }, (reason) => {
        this.closeResult =
          ' Dismissed ${this.getDismissReason(reason)}';
        let element: HTMLButtonElement = document.getElementById('ErrorButtonConstant') as HTMLButtonElement;
        element.click();
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ${reason}';
    }
  }



}
